import React from 'react';
import ICWarning from 'assets/images/backoffice/capital/ic-warning.svg';
import styles from './Message.css';

function Message(props) {
  const { children } = props;
  return (
    <div className={styles.wrapper}>
      <img src={ICWarning} alt="icon" />
      <p className={styles.text}>{children}</p>
    </div>
  );
}

export default Message;
